import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "balanceHeader" };
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import TransactionsList from './elements/TransactionsList.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import AccountButton from './elements/AccountButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountsPage',
    setup(__props) {
        const route = useRoute();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankingInfo } = useBanking();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const accounts = ref([]);
        const accountsBalance = ref(0);
        function peekingDrawerBottom() {
            const c = cookies?.get('sb');
            let ret = 44;
            if (c) {
                ret += parseInt(c);
            }
            return ret + 'px';
        }
        function onLoad() {
            getCustomer();
            getBankingInfo(() => {
                if (state.bankInfo) {
                    state.bankInfo.accounts.forEach((a) => {
                        const accountType = route.params.accountType;
                        if (a.accountType.prettyName == "Current" && accountType.toLowerCase() == "current") {
                            accounts.value.push(a);
                            accountsBalance.value += a.balance;
                        }
                        else if (a.accountType.prettyName == "Credit" && accountType.toLowerCase() == "credit") {
                            accounts.value.push(a);
                            accountsBalance.value += a.balance;
                        }
                        else if (a.accountType.prettyName == "Savings" && accountType.toLowerCase() == "savings") {
                            accounts.value.push(a);
                            accountsBalance.value += a.balance;
                        }
                    });
                }
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Accounts",
                    bgcolor: "#FCE5D4dd"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer && _unref(state).bankInfo,
                    cardBlocks: true
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).bankInfo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _cache[0] || (_cache[0] = _createTextVNode(" Total balance ")),
                                    _createElementVNode("p", null, _toDisplayString(_unref(state).formatter.format(Math.round(accountsBalance.value), false, false)), 1)
                                ]),
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (a) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass('hubItemWrapper'),
                                            key: a.id
                                        }, [
                                            _createVNode(AccountButton, {
                                                circleIcon: true,
                                                href: '#/account/' + a.id,
                                                title: a.bankDisplayName,
                                                icon: a.bank.logoPath ? require('@/assets/logos/' + a.bank.logoPath) : require('@/assets/round1.png'),
                                                provider: a.displayName,
                                                balance: _unref(state).formatter.format(Math.round(a.balance))
                                            }, null, 8, ["href", "title", "icon", "provider", "balance"])
                                        ]));
                                    }), 128))
                                ]),
                                _cache[1] || (_cache[1] = _createElementVNode("div", { style: { "clear": "both", "padding-bottom": "110px" } }, null, -1)),
                                _createVNode(DrawerPanel, {
                                    bottom: peekingDrawerBottom(),
                                    title: "Recent Transactions",
                                    backgroundColor: "white",
                                    openBackgroundColor: "white"
                                }, {
                                    default: _withCtx(() => [
                                        (_unref(state).bankInfo)
                                            ? (_openBlock(), _createBlock(TransactionsList, {
                                                key: 0,
                                                showDateTotal: true,
                                                search: "true",
                                                transactions: _unref(state).bankInfo.recentTransactions,
                                                formatter: _unref(state).formatter,
                                                today: _unref(state).today,
                                                yesterday: _unref(state).yesterday
                                            }, null, 8, ["transactions", "formatter", "today", "yesterday"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }, 8, ["bottom"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
